import React from 'react';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import Media from '../ExerciseMedia';
import ExerciseText from '../ExerciseText';

import { CoreExercise } from '../../types';

interface ExerciseExplanationProps {
  exercise: CoreExercise;
}

const ExerciseExplanation = (props: ExerciseExplanationProps) => {
  const { exercise } = props;
  const { media, text } = exercise.explanation || {};
  const intl = useIntl();

  if (isEmpty(text) && isEmpty(media)) {
    return <span />;
  }

  return (
    <Box mt={2}>
      <Typography variant="h6" gutterBottom>
        {intl.formatMessage({ id: 'solution' })}
      </Typography>
      <ExerciseText text={text} />
      <Media media={media} />
    </Box>
  );
};

export default ExerciseExplanation;
